export const BANNERS_BASE_URL =
    "https://tfzosqloquobjmszssig.supabase.co/storage/v1/object/public/banners";

export const TOTAL_SLIDES = 15;
